<!-- 弹框 -->
<template>
  <div class="fddform-pop">
    <div :class="['fddform-pop-box', 'dialog-top', customClass]">
      <div class="fddform-pop-box-title">
        <span class="title">{{ title }}</span>
        <a class="close" @click="cancel">
          <span class="use-close"></span>
        </a>
      </div>
      <div v-if="useHtmlString" :class="['fddform-pop-main', { 'fddform-pop-center': center }]" v-html="message">
        {{ message }}
      </div>
      <div v-else :class="['fddform-pop-main', { 'fddform-pop-center': center }]">
        <div class="fddform-pop-main-text">{{ message }}</div>
      </div>
      <div v-if="showButton" class="fddform-pop-main-link">
        <fdd-button v-if="showConfirmButton" type="primary" @click="enter">{{ confirmButtonText }}</fdd-button>
        <fdd-button v-if="showCancelButton" @click="cancel">{{ cancelButtonText }}</fdd-button>
      </div>
    </div>
    <div class="fddform-pop-bg" @click="closeOnClickModal && cancel"></div>
  </div>
</template>
<script>
  export default {
    name: 'MessageBox',
    data() {
      return {
        title: '提示', // 左上角title
        message: '', // 中间层文本内容
        confirmButtonText: '确 定', //确定按钮的文字
        cancelButtonText: '取 消', //取消按钮的文字
        showCancelButton: true, //是否显示取消按钮
        showConfirmButton: true, //是否显示确定按钮
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        customClass: '', //MessageBox 的自定义类名
        useHtmlString: false, //是否使用html片段
        center: false, //文字是否居中
        callback: null,
        closeOnRouteChange: true // 路由改变后关闭
      }
    },
    computed: {
      showButton() {
        return this.showCancelButton || this.showConfirmButton
      }
    },
    methods: {
      // 确认
      enter() {
        this.resolve && this.resolve()
        // 取消
        this.close('yes')
      },
      // 取消
      cancel() {
        if (typeof this.callback === 'function') {
          this.callback()
        }
        this.close('no')
      }
    }
  }
</script>
